import CryptoJS from "crypto-js";
import {
  decryptObject,
  decryptString,
  decryptStringTID,
  encryptObject,
  encryptString,
  encryptStringTID,
} from "./services/criptoJSServices";

export const encryptData = (data, key) => {
  // Convert data to a string and then encrypt it
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
  ).toString();
  return encryptedData;
};

export const decryptData = (encryptedData, key) => {
  // Decrypt data using the same key
  const bytes = CryptoJS.AES.decrypt(encryptedData, key);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};

//Applicant DoB
export const setApplicantBirthDate = (ApplicantBirthDate) => {
  var year = ApplicantBirthDate.split("-");
  sessionStorage.setItem("year", JSON.stringify(year[0]));
};

export const getApplicantBirthDate = () => {
  const year = JSON.parse(sessionStorage.getItem("year"));
  return year;
};

//dob
export const setyearSession = (dob) => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  var appDoB = dob;
  var year = appDoB.split("-");
  sessionStorage.setItem(`year${tabId}`, JSON.stringify(year[0]));
};

export const setTabID = () => {
  try {
    if (!sessionStorage.getItem("t_3b_1d_1")) {
      const uniqueID = encryptStringTID(Date.now().toString()); // Ensure encryptString is defined
      sessionStorage.setItem("t_3b_1d_1", uniqueID);
    }
  } catch (error) {
    console.error("An error occurred while setting the tab ID:", error);
  }
};

export const getTabID = () => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    return decryptStringTID(tabId);
  } catch (error) {
    console.error("An error occurred while getting the tab ID:", error);
  }
  // const tabId = sessionStorage.getItem("t_3b_1d_1");
  // return  decryptString(tabId);
};

//dob
export const setTStageID = (stageID) => {
  const data = sessionStorage.getItem("t_3b_1d_1");
  //const newData = encryptString(stageID)
  sessionStorage.setItem(`s_T_g${data}I_d`, encryptString(stageID));
};

export const getStageID = () => {
  const data = sessionStorage.getItem("t_3b_1d_1");
  // if (!sessionStorage.getItem(`s_T_g${data}I_d`)) {
  const newStage = sessionStorage.getItem(`s_T_g${data}I_d`);
  return decryptString(newStage);
  // } else {
  //   return null
  // }
};

export const getdob = () => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  const year = JSON.parse(sessionStorage.getItem(`year${tabId}`));
  return year;
};

// Attachment
export const setAttachment = (Attachment) => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  sessionStorage.setItem(`Atta${tabId}chment`, JSON.stringify(Attachment));
};

// profile photo
export const getprofile_photo = () => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  const Attachment = JSON.parse(sessionStorage.getItem(`Atta${tabId}chment`));
  return Attachment[0].Photo;
};

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx user  xxxxxxxxxxxxxxxxxxxxxxx
export const setUserInfo = (userData) => {
  try {
    sessionStorage.setItem(
      `u_Se_${getTabID()}r_In_fo`,
      encryptObject(userData),
    );
  } catch (error) {
    console.error("An error occurred while setting userInfo:", error);
  }
};

export const getUserInfo = (userData) => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};
export const getAppType = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    )?.ApplicationFrom;
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};

export const getEmail = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    )?.Email;
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};

export const getFullName = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    )?.FullName;
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};

export const getAppId = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    )?.ApplicationID;
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx address  xxxxxxxxxxxxxxxxxxxxxxx
export const setAddressInfo = (addressInfo) => {
  try {
    sessionStorage.removeItem(`a_Dd_${getTabID()}r_esIn_fo`);
    sessionStorage.setItem(
      `a_Dd_${getTabID()}r_esIn_fo`,
      encryptObject(addressInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting addressinfo:", error);
  }
};

export const getAddressInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`a_Dd_${getTabID()}r_esIn_fo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting addressinfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx parent  xxxxxxxxxxxxxxxxxxxxxxx
export const setParentInfo = (addressInfo) => {
  try {
    sessionStorage.removeItem(`pr${getTabID()}ntInf`);
    sessionStorage.setItem(`pr${getTabID()}ntInf`, encryptObject(addressInfo));
  } catch (error) {
    console.error("An error occurred while setting parentinfo:", error);
  }
};

export const getParentInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`pr${getTabID()}ntInf`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting parentinfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx Travel  xxxxxxxxxxxxxxxxxxxxxxx
export const setTravelInfo = (travelInfo) => {
  try {
    sessionStorage.removeItem(`t_Rv_${getTabID()}E_llIn_fo`);
    sessionStorage.setItem(
      `t_Rv_${getTabID()}E_llIn_fo`,
      encryptObject(travelInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting travelInfo:", error);
  }
};

export const getTravelInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`t_Rv_${getTabID()}E_llIn_fo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting travelInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx Travel  xxxxxxxxxxxxxxxxxxxxxxx
export const setEmergenceInfo = (travelInfo) => {
  try {
    sessionStorage.removeItem(`em${getTabID()}ncIn_fo`);
    sessionStorage.setItem(`em${getTabID()}ncIn_fo`, encryptObject(travelInfo));
  } catch (error) {
    console.error("An error occurred while setting emergenceInfo:", error);
  }
};

export const getEmergenceInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`em${getTabID()}ncIn_fo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting emergenceInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx Travel  xxxxxxxxxxxxxxxxxxxxxxx
export const setDeclarationInfo = (declartionInfo) => {
  try {
    sessionStorage.removeItem(`s_el_F${getTabID()}_d_inf`);
    sessionStorage.setItem(
      `s_el_F${getTabID()}_d_inf`,
      encryptObject(declartionInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting declarationInfo:", error);
  }
};

export const getDeclarationInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`s_el_F${getTabID()}_d_inf`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting declarationInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx Travel  xxxxxxxxxxxxxxxxxxxxxxx
export const setQrVerificationInfo = (declartionInfo) => {
  try {
    sessionStorage.removeItem(`qR${getTabID()}V`);
    sessionStorage.setItem(`qR${getTabID()}V`, encryptObject(declartionInfo));
  } catch (error) {
    console.error("An error occurred while setting qrVerificationInfo:", error);
  }
};

export const getQrVerificationInfo = () => {
  try {
    return decryptObject(sessionStorage.getItem(`qR${getTabID()}V`) || "{}");
  } catch (error) {
    console.error("An error occurred while getting qrVerificationInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx  nida 1BJS info management xxxxxxxxxxxxxxxxxxxxxxx
export const set1BpersonalInfo = (declartionInfo) => {
  try {
    sessionStorage.removeItem(`p1b${getTabID()}inf`);
    sessionStorage.setItem(
      `p1b${getTabID()}inf`,
      encryptObject(declartionInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting qrVerificationInfo:", error);
  }
};

export const get1BpersonalInfo = () => {
  try {
    return decryptObject(sessionStorage.getItem(`p1b${getTabID()}inf`) || "{}");
  } catch (error) {
    console.error("An error occurred while getting qrVerificationInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const setCounties = (coutries) => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  sessionStorage.setItem(`c_O_u_N_tries${tabId}`, JSON.stringify(coutries));
};

export const getStoredCountries = () => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  const data = JSON.parse(
    sessionStorage.getItem(`c_O_u_N_tries${tabId}`) || "{}",
  );
  return data;
};

export const setToken = (token) => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  if (token) {
    sessionStorage.removeItem(`t_O_${tabId}k_E_n`);
    sessionStorage.setItem(`t_O_${tabId}k_E_n`, JSON.stringify(token));
  }
};

export const getToken = () => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  const token = JSON.parse(
    sessionStorage.getItem(`t_O_${tabId}k_E_n`) || "null",
  );
  return token;
};

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx eml info management xxxxxxxxxxxxxxxxxxxxxxx
export const setEmailInfo = (declartionInfo) => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    sessionStorage.removeItem(`exmxaxixlx${tabId}xixnxf`);
    sessionStorage.setItem(
      `exmxaxixlx${tabId}xixnxf`,
      encryptObject(declartionInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting pgInfo:", error);
  }
};

export const getEmailInfo = () => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    return decryptObject(
      sessionStorage.getItem(`exmxaxixlx${tabId}xixnxf`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting pgInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//xxxxxxxxxxxxxxxxxxxxxxxxxxxx  nida 1BJS info management xxxxxxxxxxxxxxxxxxxxxxx
export const setPageInfo = (declartionInfo) => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    sessionStorage.removeItem(`pxaxgxexix${tabId}xixnxf`);
    sessionStorage.setItem(
      `pxaxgxexix${tabId}xixnxf`,
      encryptObject(declartionInfo),
    );
  } catch (error) {
    console.error("An error occurred while setting pgInfo:", error);
  }
};

export const getPageInfo = () => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    return decryptObject(
      sessionStorage.getItem(`pxaxgxexix${tabId}xixnxf`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting pgInfo:", error);
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx end xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

export const getAttachment = (AttachmentID) => {
  const tabId = sessionStorage.getItem("t_3b_1d_1");
  const Attachment = JSON.parse(sessionStorage.getItem(`Atta${tabId}chment`));
  switch (AttachmentID) {
    case 1:
      return Attachment[1].Photo;
    case 2:
      return Attachment[2].Photo;
    case 3:
      return Attachment[3].Photo;
    case 4:
      return Attachment[4].Photo;
    case 5:
      return Attachment[5].Photo;
    case 6:
      return Attachment[6].Photo;
  }
};

export const getphoto = () => {
  const photoID = JSON.parse(sessionStorage.getItem("photo"));
  return photoID;
};

export const setReplacementDetails = (fname, mname, lname, photo, appNo) => {
  sessionStorage.setItem("appNo", JSON.stringify(appNo));
  sessionStorage.setItem("fname", JSON.stringify(fname));
  sessionStorage.setItem("mname", JSON.stringify(mname));
  sessionStorage.setItem("lname", JSON.stringify(lname));
  sessionStorage.setItem("photo", JSON.stringify(photo));
};

export const continueto = (stageID) => {
  switch (stageID) {
    case 1:
      return "./stp1";
      break;
    case 2:
      return "./stp2";
      break;
    case 3:
      return "./stp3";
      break;
    case 4:
      return "./stp4";
      break;
    case 5:
      return "./stp5";
      break;
    case 6:
      return "./stp6";
      break;
    case 7:
      return "./stp7";
      break;
    case 8:
      return "./stp8";
      break;
  }
};

export const setFullMkoko = (data) => {
  if (data) {
    sessionStorage.removeItem("m_K_o_K_o");
    sessionStorage.setItem("m_K_o_K_o", JSON.stringify(data));
  } else {
    sessionStorage.removeItem("m_K_o_K_o");
    sessionStorage.setItem(null);
  }
};

export const getFullMkoko = () => {
  const data = JSON.parse(sessionStorage.getItem("m_K_o_K_o"));
  return data;
};

export const removeFullMkoko = () => {
  sessionStorage.removeItem("m_K_o_K_o");
};

export const logout = () => {
  localStorage.clear();
  sessionStorage.clear();
};
